import React, { useLayoutEffect, useState } from "react";
import { Col, Image, Row, Table } from "react-bootstrap";
import retern from "../../assets/svg/retern.svg";
import photoProfile from "../../assets/png/Profile_photo.png";
import cercle from "../../assets/svg/image.svg";
import { useLocation, useNavigate } from "react-router-dom";
import SideBar from "../../Component/sidebar/SideBar";
import "./DetailCombattant.scss";
import {
  API_LIST,
  API_MULTI_TECH, SERVER_URL
} from "../../api/entryPoint";
import axiosService from "../../services/Axios/axiosServices";
export default function DetailCombattant() {
  const [hits, setHits] = useState([]);
  const [point, setPoint] = useState([]);
  const [points, setPoints] = useState([]);
  const [match, setMatch] = useState([]);
  const [detail, setDetail] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const getList = async () => {
    axiosService
      .get(SERVER_URL + API_LIST + location.state.detail)
      .then((response) => {
        setHits(response.data.combattant);
        setDetail(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTechnique = async (body) => {
    axiosService
      .post(SERVER_URL + API_MULTI_TECH, body)
      .then((response) => {
        setPoint(response.data.point);
        setMatch(response.data);
        setPoints(response.data.length_array);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const arrayPoint = () => {
    point.map((subarray) => {
      while (subarray.length < 30) {
        subarray.push("0");
      }
      return subarray;
    });
  };
  arrayPoint();
  /*eslint-disable */
  useLayoutEffect(() => {
    getList();
    getTechnique(location.state.ids);
  }, []);
  /*eslint-enable */
  const returnBack = () => {
    navigate("/detail", {
      state: { detail: location.state.detail, match: location.state.match },
    });
  };
  const percent = (partiel, total) => {
    if (partiel === 0) {
      return 0;
    } else {
      return (100 * (partiel / total)).toFixed(2);
    }
  };
  function WinnerCombatt() {
    return (
      <div className="main">
        <div className="title-font d-flex">
          <Image
            src={retern}
            alt="return"
            className="mr-1 cursor-bottom"
            onClick={returnBack}
          ></Image>
          <p className="name-margin-top name-title1 mt-3">
            {hits.winner_fighter}
          </p>
        </div>
        <Row className="d-flex-evently margin-top-20 mb-3">
          <Col className="detail-col">
            <div className="d-flex">
              <div className="m-r-25">
                <Image
                  src={photoProfile}
                  alt="profile"
                  className="mage-style1"
                ></Image>
              </div>
              <Col lg={3}>
                <div className="d-flex">
                  <div className="detail-div w-20 pb-2">Genre</div>
                  <div className="data-div pt-1">{hits.gender}</div>
                </div>
                <div className="d-flex">
                  <div className="detail-div w-20 pb-2">Pays</div>
                  <div className="data-div pt-1">{hits.country_one}</div>
                </div>
                <div className="d-flex">
                  <div className="detail-div w-20 pb-2">Référence</div>
                  <div className="data-div pt-1">Référence</div>
                </div>
                <div className="d-flex">
                  <div className="detail-div w-20">Catégorie de Poids</div>
                  <div className="data-div pt-1">{hits.category_weight}</div>
                </div>
              </Col>
              <Col lg={3}>
                <div className="d-flex ">
                  <div className="detail-div pb-2">Nb de combats</div>
                  <div className="data-div pt-1">
                    {detail.all_plyed_from_winner}
                  </div>
                </div>
                <div className="d-flex ">
                  <div className="detail-div pb-2">Gagnés</div>
                  <div className="data-div pt-1">
                    {detail.won_match_from_winner}
                  </div>
                </div>
                <div className="d-flex ">
                  <div className="detail-div pb-2">Perdus</div>
                  <div className="data-div pt-1">
                    {detail.losed_match_from_winner}
                  </div>
                </div>
                <div className="d-flex">
                  <div className="detail-div">Efficacité</div>
                  <div className="data-div pt-1">
                    {percent(
                      detail?.won_match_from_winner,
                      detail?.all_plyed_from_winner
                    )}
                    %
                  </div>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
        <Row className="d-flex-evently margin-top-20">
          <Col lg={4} className="detail-col">
            <div>
              <div className="font-title-cercle color-green">ATTAQUES</div>
              <div className="d-flex">
                <Col>
                  <div>
                    <div>Avant gauche</div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-red"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                  </div>
                  <div>
                    <div>Arriére gauche</div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-red"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                  </div>
                </Col>
                <Col>
                  <Image src={cercle} alt="cercle" className="cercle"></Image>
                </Col>
                <Col>
                  <div>
                    <div>Avant droit</div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-red"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                  </div>
                  <div>
                    <div>Arriére droit</div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-red"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                  </div>
                </Col>
              </div>
            </div>
          </Col>
          <Col lg={4} className="detail-col">
            <div className="font-title-cercle color-red">EN DANGER</div>
            <div className="d-flex">
              <Col>
                <div>
                  <div>Avant gauche</div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-red"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                </div>
                <div>
                  <div>Arriére gauche</div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-red"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                </div>
              </Col>
              <Col>
                <Image src={cercle} alt="cercle" className="cercle"></Image>
              </Col>
              <Col>
                <div>
                  <div>Avant droit</div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-red"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                </div>
                <div>
                  <div>Arriére droit</div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-red"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
        <Row className="margin-top-20">
          <Table className="width-table">
            <thead>
              <tr>
                <th>Adversaire</th>
                <th>Resultat</th>
                <th className="th-width-table"></th>
                <th>TS</th>
                <th>k</th>
                <th>++</th>
                <th>+</th>
              </tr>
            </thead>
            <tbody className="">
              {" "}
              {point
                ? point.map(function (subarray, index) {
                    return (
                      <tr key={index} className="custom_td">
                        <td>{hits.losing_fighter}</td>
                        <td>
                          {match.fighters[index].losing_fighter ===
                          hits.winner_fighter ? (
                            <div>Perdu</div>
                          ) : match.fighters[index].winner_fighter ===
                            hits.winner_fighter ? (
                            <div>Gagné</div>
                          ) : null}
                        </td>
                        <td className="display-flex-1">
                          {subarray &&
                            subarray.map((item) => {
                              return item === "0.0" ||
                                item === "0" ||
                                item === "nan" ? (
                                <div className="white-color"></div>
                              ) : item === "1.0" || item === "1" || item === "10" || item === "10.0"  ? (
                                <div className="green-color"></div>
                              ) : item === "Kinsa" ? (
                                <div className="gray-color"></div>
                              ) : (
                                <div></div>
                              );
                            })}
                        </td>
                        <td>{points ? points[index] : null}</td>
                        <td className="color-kinsa">
                          {match ? match.frequency[index].aKinsa : null}
                        </td>
                        <td className="color-red-text">
                          {match ? match.frequency[index].a10 : null}
                        </td>
                        <td className="color-green-text ">
                          {match ? match.frequency[index].a1 : null}
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </Table>
        </Row>
      </div>
    );
  }
  function LoserCombatt() {
    return (
      <div className="main">
        <div className="title-font d-flex">
          <Image
            src={retern}
            alt="return"
            className="mr-1 cursor-bottom"
            onClick={returnBack}
          ></Image>
          <p className="name-margin-top color-name mt-3">
            {hits.losing_fighter}
          </p>
        </div>
        <Row className="d-flex-evently margin-top-20 mb-3">
          <Col className="detail-col">
            <div className="d-flex">
              <div className="m-r-25">
                <Image
                  src={photoProfile}
                  alt="profile"
                  className="mage-style1"
                ></Image>
              </div>
              <Col lg={3}>
                <div className="d-flex">
                  <div className="detail-div w-20 pb-2">Genre</div>
                  <div className="data-div pt-1">{hits.gender}</div>
                </div>
                <div className="d-flex">
                  <div className="detail-div w-20 pb-2">Pays</div>
                  <div className="data-div pt-1">{hits.country_one}</div>
                </div>
                <div className="d-flex">
                  <div className="detail-div w-20 pb-2">Référence</div>
                  <div className="data-div pt-1">Référence</div>
                </div>
                <div className="d-flex">
                  <div className="detail-div w-20">Catégorie de Poids</div>
                  <div className="data-div pt-1">{hits.category_weight}</div>
                </div>
              </Col>
              <Col lg={3}>
                <div className="d-flex ">
                  <div className="detail-div pb-2">Nb de combats</div>
                  <div className="data-div pt-1">
                    {detail.all_plyed_from_loser}
                  </div>
                </div>
                <div className="d-flex ">
                  <div className="detail-div pb-2">Gagnés</div>
                  <div className="data-div pt-1">
                    {detail.won_match_from_looser}
                  </div>
                </div>
                <div className="d-flex ">
                  <div className="detail-div pb-2">Perdus</div>
                  <div className="data-div pt-1">
                    {detail.losed_match_from_looser}
                  </div>
                </div>
                <div className="d-flex">
                  <div className="detail-div">Efficacité</div>
                  <div className="data-div pt-1">
                    {percent(
                      detail.won_match_from_looser,
                      detail.all_plyed_from_loser
                    )}
                    %
                  </div>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
        <Row className="d-flex-evently margin-top-20">
          <Col lg={4} className="detail-col">
            <div>
              <div className="font-title-cercle color-green">ATTAQUES</div>
              <div className="d-flex">
                <Col>
                  <div>
                    <div>Avant gauche</div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-red"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                  </div>
                  <div>
                    <div>Arriére gauche</div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-red"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                  </div>
                </Col>
                <Col>
                  <Image src={cercle} alt="cercle" className="cercle"></Image>
                </Col>
                <Col>
                  <div>
                    <div>Avant droit</div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-red"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                  </div>
                  <div>
                    <div>Arriére droit</div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-red"></div>
                      <div></div>
                    </div>
                    <div className="d-flex">
                      <div className="cercle-green"></div>
                      <div></div>
                    </div>
                  </div>
                </Col>
              </div>
            </div>
          </Col>
          <Col lg={4} className="detail-col">
            <div className="font-title-cercle color-red">EN DANGER</div>
            <div className="d-flex">
              <Col>
                <div>
                  <div>Avant gauche</div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-red"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                </div>
                <div>
                  <div>Arriére gauche</div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-red"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                </div>
              </Col>
              <Col>
                <Image src={cercle} alt="cercle" className="cercle"></Image>
              </Col>
              <Col>
                <div>
                  <div>Avant droit</div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-red"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                </div>
                <div>
                  <div>Arriére droit</div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-red"></div>
                    <div></div>
                  </div>
                  <div className="d-flex">
                    <div className="cercle-green"></div>
                    <div></div>
                  </div>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
        <Row className="margin-top-20">
          <Table className="width-table">
            <thead>
              <tr>
                <th>Adversaire</th>
                <th>Resultat</th>
                <th className="th-width-table"></th>
                <th>TS</th>
                <th>k</th>
                <th>++</th>
                <th>+</th>
              </tr>
            </thead>
            <tbody>
              {point
                ? point.map(function (subarray, index) {
                    return (
                      <tr key={index} className="custom_td">
                        <td>{hits.winner_fighter}</td>
                        <td>
                          {match.fighters[index].losing_fighter ===
                          hits.losing_fighter ? (
                            <div>Perdu</div>
                          ) : match.fighters[index].winner_fighter ===
                            hits.losing_fighter ? (
                            <div>Gagné</div>
                          ) : null}
                        </td>
                        <td className="display-flex-1">
                          {subarray &&
                            subarray.map((item) => {
                              return item === "0.0" ||
                                item === "0" ||
                                item === "nan" ? (
                                <div className="white-color"></div>
                              ) : item === "1.0" || item === "1" || item === "10" || item === "10.0" ? (
                                <div className="green-color"></div>
                              )  : item === "Kinsa" ? (
                                <div className="gray-color"></div>
                              ) : (
                                <div></div>
                              );
                            })}
                        </td>
                        <td>{points ? points[index] : null}</td>
                        <td className="color-kinsa">
                          {match ? match.frequency[index].aKinsa : null}
                        </td>
                        <td className="color-red-text">
                          {match ? match.frequency[index].a10 : null}
                        </td>
                        <td className="color-green-text ">
                          {match ? match.frequency[index].a1 : null}
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </Table>
        </Row>
      </div>
    );
  }
  return (
    <>
      <SideBar></SideBar>
      {location.state.status === "looser" ? LoserCombatt() : WinnerCombatt()}
    </>
  );
}
